import _ from 'lodash';

const initState = () => ({
  reports: [],
});

export default {
  namespaced: true,
  state: initState(),
  mutations: {
    addReport(state, payload) {
      state.reports.push(payload.report);
    },
    reset: (state) => _.assign(state, initState()),
    markReportAsRead(state, payload) {
      const report = state.reports.find((r) => r.id === payload.id);
      if (report) {
        report.read = true;
      }
    }
  },
  actions: {},
  getters: {
    unreadReports: (state) => state.reports.filter((r) => !r.read),
    unreadReportsCount: (state, getters) => getters.unreadReports.length,
  },
};
